module["exports"] = [
  "#{city_root}#{city_suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/address/city.js
 ** module id = 827
 ** module chunks = 0
 **/